import { put, select, takeLatest } from 'redux-saga/effects';
import requestWrapper from 'utils/requestWrapper';
import history from 'utils/history';
import { LOAD_PLANS, CHANGE_PLANS, DELETE_PLANS } from './constants';

import {
  loadPlansError,
  loadPlansSuccess,
  changePlansError,
  changePlansSuccess,
  deletePlansSuccess,
  deletePlansError,
} from './actions';


import { notification } from 'antd';

export function* loadPlans() {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(
      localStorage.getItem('schoolinked_user'),
    );

    // we get the campaigns linked to the plans
    const plansList = yield requestWrapper(
      'GET',
      `plans/`,
      '',
      currentUser.token,
    );

    if (!plansList) {
      yield put(loadPlansSuccess(false));
    } else {
      yield put(loadPlansSuccess(plansList));
    }
  } catch (error) {
    yield put(loadPlansError(error));
  }
}

export function* changePlans(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(
      localStorage.getItem('schoolinked_user'),
    );
    //const plansData = yield select(selectplansData());
    const { plansData } = action;

    let changedPlans = false,
      isNew = !plansData.hasOwnProperty('_id');

    if (plansData._id === undefined) {
      changedPlans = yield requestWrapper(
        'POST',
        'plans/new/',
        plansData,
        currentUser.token,
      );
      notification.success({ message: 'Created' });
    } else {
      changedPlans = yield requestWrapper(
        'PATCH',
        'plans/',
        plansData,
        currentUser.token,
      );
      notification.success({ message: 'Updated' });
    }

    if (!changedPlans) {
      yield put(changePlansSuccess(false));
    } else {
      // if new we update the url, item props will be updated
      if (isNew) {
        //history.push({ pathname: `/plans/`+plansData._id });
      }
      yield put(changePlansSuccess(changedPlans));
    }
  } catch (error) {
    yield put(changePlansError(error));
  }
}

export function* deletePlans(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(
      localStorage.getItem('schoolinked_user'),
    );
    const { id } = action;

    const deletePlans = yield requestWrapper(
      'PATCH',
      `plans/remove`,
      {
        _id: id,
        active: false,
      },
      currentUser.token,
    );

    if (deletePlans) {
      yield put(deletePlansSuccess());
    }
  } catch (error) {
    yield put(deletePlansError(error));
  }
}

export default function* plansSaga() {
  yield takeLatest(LOAD_PLANS, loadPlans);
  yield takeLatest(CHANGE_PLANS, changePlans);
  yield takeLatest(DELETE_PLANS, deletePlans);
}
